import SocialProof from '~/pages/anatomy/socialProof/libs/components/SocialProof'
import { TPageProps } from '~/shared/types/commonTypes'

const SocialProofAnatomy = ({ nextPagePath, pageId }: TPageProps) => (
  <SocialProof nextPagePath={nextPagePath} pageId={pageId} />
)

export default SocialProofAnatomy
